export const THEMES_ROUTES = {
  themes: '/themes',
  themesUpsell: '/themes/upsell',
  contactInfo: '/preferences',
  passwordProtected: '/themes/password-protected',
  socialNetworks: '/online-store/social-networks',
};
